"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefaultValues = void 0;
const isDefaultValues = (defaultValues) => typeof defaultValues === 'object';
exports.isDefaultValues = isDefaultValues;
//# sourceMappingURL=isDefaultValues.js.map